// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Lz4f","colMin":"styles_colMin__nqnaU"};